import { type ReactElement, useEffect } from 'react';
import { ScopeMarketNotice, useScopeMarket } from './scope-market';

/**
 * The market of a per-market Admin screen (W6-ADMIN-SCREENS D401; owner 2026-10-12). It used to be a second market
 * selector under the header's scope; now the scope is the ONLY market control: this keeps the parent's `value` equal to
 * the scoped market (`useScopeMarket`) and draws nothing while one is resolved. While the scope is a country or global
 * with several markets it shows the "pick a city in the scope" notice and the value is cleared, so no load button can
 * keep working on a market the scope no longer shows (review W6N-04).
 */
export function MarketField({ value, onChange }: { id?: string; value: string; onChange: (marketId: string) => void; hintId?: string }): ReactElement | null {
  const { market, choices } = useScopeMarket();
  useEffect(() => {
    const next = market ?? '';
    if (next !== value) onChange(next);
  }, [market, value, onChange]);
  return market === undefined ? <ScopeMarketNotice choices={choices} /> : null;
}
